/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'coupon-info': {
    width: 214.648,
    height: 200,
    viewBox: '0 0 1099 1024',
    data: '<defs/><path pid="0" d="M1097.642 530.391V312.714H0v217.94a26.185 26.185 0 0012.215 21.764c39.801 26.185 65.648 68.605 65.648 116.401s-25.847 90.17-65.648 116.417A26.185 26.185 0 000 807.001v215.29h1097.642V807.246a26.185 26.185 0 00-12.322-21.81c-40.048-26.186-65.987-68.683-65.987-116.618s26-90.4 65.987-116.617a26.185 26.185 0 0012.322-21.81zM233.79 942.841h-78.371v-78.479h78.37zm0-156.973h-78.371v-78.495h78.37zm0-156.99h-78.371V550.4h78.37zm0-156.988h-78.371v-78.479h78.37zm0 0M625.367 0L232.341 236.115h551.324zm0 0"/>'
  }
})
